import moment from 'moment'

import { ActivityModel } from '@/modules/drivers/types/activities'

export const getVisibleActivities = (
  activities: ReadonlyArray<ActivityModel>,
): ReadonlyArray<ActivityModel> => {
  const cardSpans = activities
    .filter((a) => a.driverTachographChartId != null)
    .map((a) => ({
      s: moment(a.startTime).valueOf(),
      e: moment(a.endTime).valueOf(),
    }))
    .filter((span) => !isNaN(span.s) && !isNaN(span.e) && span.e > span.s)

  if (cardSpans.length === 0) return activities

  return activities.filter((a) => {
    if (a.driverTachographChartId != null) return true
    const s = moment(a.startTime).valueOf()
    const e = a.endTime ? moment(a.endTime).valueOf() : s
    return !cardSpans.some((span) => span.s < e && span.e > s)
  })
}
